import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
    pagination:{
        '&.MuiPaginationItem-root':{
          borderRadius:"3px",
          padding:"10px",
          '& .MuiSvgIcon-root':{
            fontSize:30,
            background:'#1972d2',
            color:"white",
            borderRadius:'3px'
          }
        }
       },
       footer:{
        '&.MuiGrid-root':{     
        display:'flex',
        justifyContent:'space-between',
        backgroundColor:"#fff",
        borderTop:`1px solid #ccc`,
        padding:"6px",
        alignItems:'center'
        } 
    },
    pagination:{
      '&.MuiPaginationItem-root':{
          // backgroundColor:"red",
          borderRadius:"5px",
          padding:"10px",

          '&.Mui-selected':{
          backgroundColor:"#A06EE1",
          '&:hover': {
              backgroundColor: '#ccc', // Replace with your desired hover color
              color: '#000', // Replace with your desired hover text color
          },
          },
          
          '& .MuiSvgIcon-root':{
              fontSize:24
          }
      }
  },
  paginationOne:{
    '&.MuiGrid-root':{     
    display:'flex',
    alignItems:'center',
    } 
}, 
  paginationAutocomplete:{
    '&.MuiTextField-root':{
    padding:'0px',
    width:'65px',
    }
},
}))